import React from 'react';
import styled from 'styled-components';

// [claude] Canonical themed text input for the Ink design system (2026-07).
// Promoted from OAuthFlow/shared/OAuthInput.jsx (which now re-exports this file)
// so the SSO/OAuth box style is THE box style site-wide. Reads tokens from the
// styled-components ThemeProvider (utility/theme.js or shared/brandingTheme.js).
// Replaces the legacy hand-rolled shared/Input.js on modernized screens.

const Wrapper = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  font-family: ${p => p.theme.fontFamily};
  font-size: 13px;
  font-weight: 500;
  color: ${p => p.theme.textSecondary};
  line-height: 18px;
  margin-bottom: 6px;
`;

const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 16px;
  background: ${p => p.theme.inputBg};
  border: 1px solid ${p => p.hasError ? p.theme.error : p.theme.inputBorder};
  border-radius: ${p => p.theme.radius};
  font-family: ${p => p.theme.fontFamily};
  font-size: 16px;
  font-weight: 400;
  color: ${p => p.theme.text};
  line-height: 24px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${p => p.theme.textTertiary};
  }

  &:focus {
    border-color: ${p => p.hasError ? p.theme.error : p.theme.borderFocus};
    box-shadow: 0 0 0 3px ${p => p.hasError ? 'rgba(246, 113, 113, 0.1)' : p.theme.ring};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const ErrorText = styled.div`
  font-family: ${p => p.theme.fontFamily};
  font-size: 13px;
  font-weight: 400;
  color: ${p => p.theme.error};
  line-height: 18px;
  margin-top: 6px;
`;

export default function FormInput({ label, error, id, ...inputProps }) {
  return (
    <Wrapper>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Input hasError={!!error} id={id} {...inputProps} />
      {error && <ErrorText aria-live='polite'>{error}</ErrorText>}
    </Wrapper>
  );
}
